"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrganizationsEndpoints = createOrganizationsEndpoints;
/**
 * Kurum: profil, doğrulama ve ekip daveti.
 */
function createOrganizationsEndpoints(client) {
    return {
        organizations: {
            list: () => client.call('/organizations', 'get', {}),
            create: (input) => client.call('/organizations', 'post', { body: input }),
            get: (id) => client.call('/organizations/{id}', 'get', { path: { id } }),
            /** K4 · TW2 kurum ana sayfası: canlı etkinlikler, sayaçlar, taslaklar (tek okuma). */
            home: (id) => client.call('/organizations/{id}/home', 'get', { path: { id } }),
            /** Kurum kredi özeti (Story D6) — yalnız `owner` ve `admin`; diğer roller 403. */
            credits: (id) => client.call('/organizations/{id}/credits', 'get', { path: { id } }),
            /**
             * Kredi talep formunun paket fiyatları (B-21) — yalnız `owner` ve `admin`;
             * diğer roller 403, üye olmayan 404. Fiyat istemci paketinde yoktur.
             */
            creditPrices: (id) => client.call('/organizations/{id}/credits/prices', 'get', { path: { id } }),
            /** Kurum talebi (B-21): kredi, sözleşme, destek. Kurum ve e-posta oturumdan. */
            createRequest: (id, input) => client.call('/organizations/{id}/requests', 'post', { path: { id }, body: input }),
            update: (id, input) => client.call('/organizations/{id}', 'patch', { path: { id }, body: input }),
            members: (id) => client.call('/organizations/{id}/members', 'get', { path: { id } }),
            inviteMember: (id, input) => client.call('/organizations/{id}/members', 'post', { path: { id }, body: input }),
            changeMemberRole: (id, memberId, input) => client.call('/organizations/{id}/members/{memberId}', 'patch', {
                path: { id, memberId },
                body: input,
            }),
            /** Ekipten çıkarma. Çağıran kendi satırını çıkaramaz (409, ayrılma ucu `leave`). */
            removeMember: (id, memberId) => client.call('/organizations/{id}/members/{memberId}', 'delete', {
                path: { id, memberId },
            }),
            /**
             * Bekleyen ekip davetini iptal eder (12.10.2026). Davet bu arada kabul
             * edildiyse 409 `ORGANIZATION_INVITATION_ALREADY_ACCEPTED`: üye ÇIKARILMAZ.
             */
            cancelInvitation: (id, memberId) => client.call('/organizations/{id}/invitations/{memberId}', 'delete', {
                path: { id, memberId },
            }),
            /**
             * SAHİPLİK DEVRİ (K3 · elle test 2 Y-1): sahip, sahipliği kurumdaki başka
             * bir AKTİF üyeye devreder ve kendisi `admin` olur.
             */
            transferOwnership: (id, input) => client.call('/organizations/{id}/owner', 'post', { path: { id }, body: input }),
            /** Kullanıcının KENDİ üyeliğinden ayrılması (sahip önce devretmeli). */
            leave: (id) => client.call('/organizations/{id}/members/me', 'delete', { path: { id } }),
            /** Kurum doğrulama durumu — `orgVerify` ekranının tek kaynağı (Story 18.3). */
            verification: (id) => client.call('/organizations/{id}/verification', 'get', { path: { id } }),
            submitVerification: (id, input) => client.call('/organizations/{id}/verification', 'post', { path: { id }, body: input }),
            /** Karar bekleyen başvuruyu geri çeker; kurum `unverified`a döner. */
            withdrawVerification: (id) => client.call('/organizations/{id}/verification/withdraw', 'post', { path: { id } }),
            /** Yetki belgesini saklama süresini beklemeden kalıcı siler (KÇ 5). */
            deleteVerificationDocument: (id) => client.call('/organizations/{id}/verification/document', 'delete', { path: { id } }),
        },
        /**
         * Ekip daveti (K5) — kuruma yuvalanmaz: davet edilen kişinin elinde yalnız
         * jeton vardır, kurum kimliği yoktur (varlığı sızdırılmaz).
         */
        /**
         * Herkese açık platform yetenekleri (CLAUDE.md "kapatılmış yetenek" koşulu
         * 3): istemci kurum oluşturma girişini YALNIZ bu yanıta göre çizer.
         */
        /**
         * ORGANİZATÖR SAYFASI (14.10.2026): giriş gerektirmez, oturum varsa yalnız
         * bakanın KENDİ "Kayıtlısın" bilgisi dolar. `invite_only` sunucuda HİÇ dönmez.
         * Sorgu (`pastPage`, `pastPageSize`) Joi ile doğrulanır; şemada bildirilmediği
         * için keşif ucuyla aynı biçimde geçilir.
         */
        publicOrganizations: {
            get: (slug, query = {}) => client.call('/public/organizations/{slug}', 'get', {
                path: { slug },
                query: query,
            }),
        },
        /**
         * KURUMU TAKİP ET (kurum takibi Story 1/2). İki uç da idempotenttir ve
         * yalnız bakanın KENDİ durumunu döner; takipçi sayısı yoktur. Kurum hesabı
         * 403 alır (kitle `participant`).
         */
        organizationFollows: {
            follow: (slug, input) => client.call('/organization-follows/{slug}', 'put', { path: { slug }, body: input }),
            unfollow: (slug) => client.call('/organization-follows/{slug}', 'delete', { path: { slug } }),
        },
        capabilities: {
            get: () => client.call('/capabilities', 'get', {}),
        },
        /** "Etkinliğini düzenle, bize ulaş" formu (Story B1/B2) — kurum AÇMAZ, ödeme ALMAZ. */
        salesInquiries: {
            create: (input) => client.call('/sales-inquiries', 'post', { body: input }),
        },
        teamInvitations: {
            /** Jeton BAŞLIKTA gider, adreste değil (sıra 132). */
            lookup: (token) => client.call('/team-invitations/lookup', 'get', {
                header: { 'x-invitation-token': token },
            }),
            accept: (input) => client.call('/team-invitations/accept', 'post', { body: input }),
            decline: (input) => client.call('/team-invitations/decline', 'post', { body: input }),
            /** K4 · V8: boş kurum hesabına gelmiş davetler (oturumun adresine). */
            mine: () => client.call('/team-invitations/mine', 'get', {}),
            acceptMine: (memberId) => client.call('/team-invitations/mine/{memberId}/accept', 'post', { path: { memberId } }),
        },
    };
}
//# sourceMappingURL=organizations.js.map